var render = function render(_c,_vm){return _c('div',[_c('div',{staticClass:"d-flex w-100 justify-content-center px-2"},[_c('strong',[_vm._v("Downloading...")]),_c('b-spinner',{attrs:{"small":"","type":"grow"}}),_c('b-spinner',{attrs:{"small":"","type":"grow"}}),_c('b-spinner',{attrs:{"small":"","type":"grow"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }